import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  shifts: [],
  settings: null,
  templates: [],
  availability: [],
  unavailable: [],
};

export const SchedulerState = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    setSchedulerLoading(state, action) {
      state.loading = action?.payload;
    },
    setShifts(state, action) {
      state.shifts = action?.payload || [];
    },
    setSchedulerSettings(state, action) {
      state.settings = action?.payload || null;
    },
    setTemplates(state, action) {
      state.templates = action?.payload || [];
    },
    setAvailability(state, action) {
      state.availability = action?.payload || [];
    },
    setUnavailable(state, action) {
      state.unavailable = action?.payload || [];
    },
  },
});

export const {
  setSchedulerLoading,
  setShifts,
  setSchedulerSettings,
  setTemplates,
  setAvailability,
  setUnavailable,
} = SchedulerState.actions;

export default SchedulerState.reducer;
